export default __webpack_public_path__ + "static/media/company_purple.26029c84.png";